const QUALIFICATION_RESPONSES_KEY = 'qualificationResponses';

function nowIso() {
  return new Date().toISOString();
}

function getDefaultState() {
  const now = nowIso();
  return {
    version: 1,
    flow: 'spain_regularization_2026',
    startedAt: now,
    lastUpdatedAt: now,
    outcome: null,
    answers: [],
  };
}

function parseStoredState(rawValue) {
  if (!rawValue) return null;
  try {
    const parsed = JSON.parse(rawValue);
    if (!parsed || typeof parsed !== 'object') return null;
    if (!Array.isArray(parsed.answers)) {
      parsed.answers = [];
    }
    return parsed;
  } catch {
    return null;
  }
}

export function getQualificationResponses() {
  return parseStoredState(localStorage.getItem(QUALIFICATION_RESPONSES_KEY));
}

export function clearQualificationResponses() {
  localStorage.removeItem(QUALIFICATION_RESPONSES_KEY);
}

export function initQualificationResponses() {
  const existing = getQualificationResponses();
  if (existing) return existing;
  const state = getDefaultState();
  localStorage.setItem(QUALIFICATION_RESPONSES_KEY, JSON.stringify(state));
  return state;
}

export function upsertQualificationAnswer({ questionId, questionText, answer }) {
  const normalizedAnswer = answer === 'yes' ? 'yes' : 'no';
  const state = getQualificationResponses() || initQualificationResponses();
  const answeredAt = nowIso();
  const existingIdx = state.answers.findIndex((item) => item.questionId === questionId);
  const answerEntry = {
    questionId,
    questionText,
    answer: normalizedAnswer,
    answeredAt,
  };

  if (existingIdx >= 0) {
    state.answers[existingIdx] = answerEntry;
  } else {
    state.answers.push(answerEntry);
  }

  state.lastUpdatedAt = answeredAt;
  localStorage.setItem(QUALIFICATION_RESPONSES_KEY, JSON.stringify(state));
  return state;
}

export function setQualificationOutcome(outcome) {
  const state = getQualificationResponses() || initQualificationResponses();
  state.outcome = outcome;
  state.lastUpdatedAt = nowIso();
  localStorage.setItem(QUALIFICATION_RESPONSES_KEY, JSON.stringify(state));
  return state;
}
